var map = {
	"./-1.png": 408,
	"./1.png": 855,
	"./2.png": 39,
	"./3.png": 526,
	"./4.png": 46,
	"./backup/-1.png": 320,
	"./backup/1.png": 396,
	"./backup/2.png": 256,
	"./backup/3.png": 380,
	"./backup/4.png": 424,
	"./old/-1.png": 410,
	"./old/1.png": 304,
	"./old/2.png": 179,
	"./old/3.png": 49,
	"./old/4.png": 262,
	"./test/-1.png": 524,
	"./test/2.png": 962,
	"./test/3.png": 482,
	"./test/4.png": 283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 826;